/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './activity-service.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as shared001 from '../../../../src/main/proto/shared/activity-shared.pb';
import * as shared002 from '../../../../src/main/proto/shared/media-shared.pb';
import * as shared003 from '../../../../src/main/proto/shared/reaction.pb';
import { GRPC_ACTIVITY_SERVICE_CLIENT_SETTINGS } from './activity-service.pbconf';
/**
 * Service client implementation for api.activity.ActivityService
 */
@Injectable({ providedIn: 'any' })
export class ActivityServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /api.activity.ActivityService/Get
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetResponse>>
     */
    get: (
      requestData: thisProto.GetRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/Get',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetRequest,
        responseClass: thisProto.GetResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/GetSummaries
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetSummariesResponse>>
     */
    getSummaries: (
      requestData: thisProto.GetSummariesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetSummariesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/GetSummaries',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetSummariesRequest,
        responseClass: thisProto.GetSummariesResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/GetStats
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetStatsResponse>>
     */
    getStats: (
      requestData: thisProto.GetStatsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetStatsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/GetStats',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetStatsRequest,
        responseClass: thisProto.GetStatsResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/Update
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UpdateResponse>>
     */
    update: (
      requestData: thisProto.UpdateRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UpdateResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/Update',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateRequest,
        responseClass: thisProto.UpdateResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/Delete
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.DeleteResponse>>
     */
    delete: (
      requestData: thisProto.DeleteRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.DeleteResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/Delete',
        requestData,
        requestMetadata,
        requestClass: thisProto.DeleteRequest,
        responseClass: thisProto.DeleteResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/Upload
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UploadResponse>>
     */
    upload: (
      requestData: thisProto.UploadRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UploadResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/Upload',
        requestData,
        requestMetadata,
        requestClass: thisProto.UploadRequest,
        responseClass: thisProto.UploadResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/SetReaction
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SetReactionResponse>>
     */
    setReaction: (
      requestData: thisProto.SetReactionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SetReactionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/SetReaction',
        requestData,
        requestMetadata,
        requestClass: thisProto.SetReactionRequest,
        responseClass: thisProto.SetReactionResponse
      });
    },
    /**
     * Unary call: /api.activity.ActivityService/UpdateComment
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UpdateCommentResponse>>
     */
    updateComment: (
      requestData: thisProto.UpdateCommentRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UpdateCommentResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/api.activity.ActivityService/UpdateComment',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateCommentRequest,
        responseClass: thisProto.UpdateCommentResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_ACTIVITY_SERVICE_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'api.activity.ActivityService',
      settings
    );
  }

  /**
   * Unary call @/api.activity.ActivityService/Get
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetResponse>
   */
  get(
    requestData: thisProto.GetRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetResponse> {
    return this.$raw
      .get(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/GetSummaries
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetSummariesResponse>
   */
  getSummaries(
    requestData: thisProto.GetSummariesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetSummariesResponse> {
    return this.$raw
      .getSummaries(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/GetStats
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetStatsResponse>
   */
  getStats(
    requestData: thisProto.GetStatsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetStatsResponse> {
    return this.$raw
      .getStats(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/Update
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UpdateResponse>
   */
  update(
    requestData: thisProto.UpdateRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UpdateResponse> {
    return this.$raw
      .update(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/Delete
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.DeleteResponse>
   */
  delete(
    requestData: thisProto.DeleteRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.DeleteResponse> {
    return this.$raw
      .delete(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/Upload
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UploadResponse>
   */
  upload(
    requestData: thisProto.UploadRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UploadResponse> {
    return this.$raw
      .upload(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/SetReaction
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SetReactionResponse>
   */
  setReaction(
    requestData: thisProto.SetReactionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SetReactionResponse> {
    return this.$raw
      .setReaction(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/api.activity.ActivityService/UpdateComment
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UpdateCommentResponse>
   */
  updateComment(
    requestData: thisProto.UpdateCommentRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UpdateCommentResponse> {
    return this.$raw
      .updateComment(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
